import {timeConverter} from './utils.js'

export class Invoice{
    constructor(invoice){
        if(invoice){
            if("invoiceId" in invoice){
                this.invoiceId=invoice.invoiceId
            }
            if("amount" in invoice){
                this.amount=invoice.amount
            }
            if("balance" in invoice){
                this.balance = invoice.balance
            }
            if("generated" in invoice){
                this.generated=invoice.generated
            }
            if("status" in invoice){
                this.status=invoice.status
            }
        }

    }

    getInvoiceId(){
        if("invoiceId" in this){
            return this.invoiceId
        }
        return ""
    }
    getAmount(){
        if("amount" in this){
            return (this.amount*1).toFixed(2)
        }
        return ""
    }
    getBalance(){
        if("balance" in this){
            return (this.balance*1).toFixed(2)
        }
        return ""
    }
    getDateGenerated(){
        if("generated" in this){
            return timeConverter(this.generated)
        }
        return ""
    }
    getStatus(){
        if("status" in this){
            return this.status
        }
        return ""
    }
    getAmountPaid(){
        return (this.getAmount()-this.getBalance()).toFixed(2)
    }


}